import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
// import btnClose from '../../assets/svg/btn/close.svg'
import icSend from '../../assets/svg/steps/card/fa_send-o.svg'
import icBtnCancel from '../../assets/svg/btn/ic-cancel.svg'
import icBtnSend from '../../assets/svg/btn/ic-send.svg'
import CustomBtn from '../../components/UIBTN/CustomBtn'
import { useEffect } from 'react';
import axiosClient from '../../../axios-client';

const ConfirmMessage = ({ show, handleClose, onSubmit, phoneNumber}) => {

    const [msgCredit, setMsgCredit] = useState()
    const [confirmMsgCredit, setMsgConfirmCredit] = useState()
    // const [sendWithFormSwitch, setSendWithFormSwitch] = useState(false);

    const handleConfirm = () => {
        const dataToSend = {
            confirmationText: 'This is a confirmation',
        };

        onSubmit(dataToSend);
        handleClose();
    };

    useEffect(() => {
        fetchData();
    }, []);

    // const appSettings = () => {
    //     axiosClient.get('/app-settings')
    //         .then(({ data }) => {
    //             setMsgCredit(data.data.message_credit)
    //             setMsgConfirmCredit(data.data.confirmation_credit)
    //         })
    //         .catch(() => {
    //             setLoading(false)
    //         })
    // }

    const updateCreditState = (data) => {
        const globalCredit = data.data;

        const msgCost = globalCredit.data.custom_credit.message_credit == null ? globalCredit.message_credit : globalCredit.data.custom_credit.message_credit;
        const confirmMsg = globalCredit.data.custom_credit.confirmation_credit == null ? globalCredit.confirmation_credit : globalCredit.data.custom_credit.confirmation_credit;

        setMsgCredit(msgCost)
        setMsgConfirmCredit(confirmMsg)
    };
    
    const fetchData = () => {
        Promise.all([axiosClient.get('/app-settings'), axiosClient.get('/user')])
            .then(([appSettingsData, userData]) => {
                // console.log(appSettingsData);
                // console.log(userData);

                // Use the necessary data from each API call
                const combinedData = {
                    data: {
                        ...appSettingsData.data.data,
                        ...userData.data,
                    },
                };

                updateCreditState(combinedData);
            })
            .catch((error) => {
                console.error("An error occurred while fetching data:", error);
            });
    };

    // const handleSwitchChange = () => {
    //     setSendWithFormSwitch(!sendWithFormSwitch);
    //     isForm(sendWithFormSwitch);
    // };


    return (
        <Modal centered className='modal-lg' show={show} onHide={handleClose}>
            {/* <Modal.Header className='border-0 d-flex flex-row-reverse bd-highlight'>
                <span role='button' className='rounded-circle btn-gray' variant='none' onClick={handleClose}>
                    <img src={btnClose} alt='' />
                </span>
            </Modal.Header> */}
            <Modal.Body className='p-5 text-center'>

                <div className='w-100'>
                    <div className='row justify-content-center align-items-center'>
                        <div className='col-md-10 text-center'>
                            <img className='my-3' src={icSend} alt='' srcSet='' />
                            <h1 className='text-center title my-4'>You are about to send a WhatsApp Message to</h1>
                            <div className='row justify-content-center align-items-center'>
                                <div className="mb-4 d-flex justify-content-center align-items-center">
                                    <CustomBtn
                                        classBtn={'px-1 btn-primary d-flex justify-content-start align-items-center'}
                                        classIcon={'d-none'}
                                        className={'pe-2 ps-0 active text-center fw-bolder'}
                                        title={phoneNumber}
                                    />
                                </div>
                                {/* {sendWithForm && (
                                    <div className="mb-4 d-flex justify-content-center align-items-center select-as-form">
                                        <label className='form-check-labels'>
                                            Send As Form:
                                            <input
                                                type='checkbox'
                                                className='form-check-input ms-2'
                                                checked={sendWithFormSwitch}
                                                onChange={handleSwitchChange}
                                            />
                                        </label>
                                    </div>
                                )} */}

                                {/* {sendWithFormSwitch && sendWithForm && (
                                    <p className='mb-3'>
                                        You have selected to send this message with a form or flow.
                                    </p>
                                )} */}
                                <div className="mb-4 d-flex justify-content-center align-items-center">

                                    <span role='button' onClick={handleConfirm} className={'pe-3 me-4 btn-primary d-flex justify-content-start align-items-center py-1 text-start px-1 rounded-pill mx-1'}>
                                        <div className='d-flex align-items-center'>
                                            <span className={'d-flex text-start px-0 rounded-pill mx-0'}>
                                                <img width={38} height={38} src={icBtnSend} />
                                                <div className='d-flex align-items-center'>
                                                    <span className={'ps-2 pe-2'}>Confirm</span>
                                                </div>
                                            </span>
                                        </div>
                                    </span>


                                    <div role='button' onClick={handleClose} className={'pe-3 ms-4 bg-c-danger btn-primary d-flex justify-content-start align-items-center py-1 text-start px-1 rounded-pill mx-1'}>
                                        <div className='d-flex align-items-center'>
                                            <span className={'d-flex text-start px-0 rounded-pill mx-0'}>
                                                <img width={38} height={38} src={icBtnCancel} />
                                                <div className='d-flex align-items-center'>
                                                    <span className={'text-white ps-2 pe-2'}>Cancel</span>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* </div> */}
                            </div>
                            {/* <div className={`${!msgtError ? 'd-none' : 'd-block'} alert alert-danger my-2`} role="alert">
                                {msgtError}
                            </div> */}
                            <p className=''>This Message will cost you <span className='txt-green'>{msgCredit} credits.</span></p>
                            {/* <p className=''>For each confirmation you will receive it will cost you <span className='txt-green'>{confirmMsgCredit} additional credits.</span></p> */}
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )

    
}


export default ConfirmMessage